module.exports = __webpack_public_path__ + "img/contributor.f4702818.svg";